import { render, staticRenderFns } from "./unitStatistics.vue?vue&type=template&id=72ca718d"
import script from "./unitStatistics.vue?vue&type=script&lang=js"
export * from "./unitStatistics.vue?vue&type=script&lang=js"
import style0 from "./unitStatistics.vue?vue&type=style&index=0&id=72ca718d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports